<template>
  <div>
    <v-card>
      <video-player
        v-if="match && match.video"
        :src="match.video"
        :eventView="false"
        style="height:165px"
      ></video-player>
      <youtube-player
        v-if="match && match.youtubeVideo"
        :src="match.youtubeVideo"
        :eventView="false"
        style="height:165px"
      ></youtube-player>
      <v-card-title primary-title>
        <div>
          <div class="subheading" v-html="participant"></div>
          <div class="grey--text">{{date}}</div>
          <br>
          <div class="subheading">
            {{$tc('location')}}:&nbsp;&nbsp;
            <span class="grey--text">{{location}}</span>
          </div>
          <div class="subheading">
            {{$tc('group')}}:&nbsp;&nbsp;
            <span class="grey--text">{{phaseInfo.group}}</span>
          </div>
          <div class="subheading">
            {{$tc('phase')}}:&nbsp;&nbsp;
            <span class="grey--text">{{phaseInfo.phase}}</span>
          </div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" small @click="open()">
          <span v-if="loading">
            <v-progress-circular :size="20" :width="3" color="#FFFFFF" indeterminate></v-progress-circular>
          </span>
          <span v-else>{{$t('access')}}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { dateFormat, timeFormat } from '@/helpers/dateHelper'
import { mapState, mapActions } from 'vuex'
import VideoPlayer from '@/components/widgets/video/VideoPlayer'
import YoutubePlayer from '@/components/widgets/video/YoutubePlayer'
export default {
  name: 'MatchVideoCard',
  components: { VideoPlayer, YoutubePlayer },
  props: {
    match: {
      type: Object,
      required: true,
      default: () => { }
    },
    phaseInfo: {
      type: Object,
      required: true,
      default: () => { }
    },
    type: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      tournament: state => state.tournaments.selected
    }),
    participant () {
      if (this.type === 'users' || this.type == 'usersTeams') {
        let user = this.tournament.users.find(item => item.userId == this.match.user)
        return user ? user.name : '-'
      } else if (this.type === 'teams') {
        let homeTeam = this.tournament.teams.find(item => item.teamId == this.match.homeTeamId)
        let visitorTeam = this.tournament.teams.find(item => item.teamId == this.match.visitorTeamId)
        return `${homeTeam ? homeTeam.name : '-'}  <span class="grey--text">vs</span> ${visitorTeam ? visitorTeam.name : '-'}`
      }
    },
    date () {
      return dateFormat(this.match.date, false) + ' - ' + this.match.time
    },
    location () {
      let location = this.tournament.locations.find(item => item._id == this.match.location)
      return location ? location.name : '-'
    }
  },
  methods: {
    ...mapActions({
      getOne: 'matches/setOne'
    }),
    open () {
      this.loading = true
      this.getOne(this.match._id)
        .then(() => this.$emit('open'))
        .catch((err) => console.log(err))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<style>
</style>
